module.exports = __webpack_public_path__ + "img/202411290404.a44fa22b.png";